<header class="@container py-5">
    <div class="flex flex-col items-center @xl:flex-row @xl:justify-between">
        <a [href]="getLitFinHomePage()" target="_blank">
            <img
                src="assets/img/logos/white.svg"
                width="192"
                alt="{{ 'shared.logoAlt' | translate }}"
        /></a>
        <div
            class="flex flex-col items-center justify-between @md:justify-end @md:flex-row-reverse">
            <div class="max-w-xs min-w-[160px] py-8 @xl:py-4 @xl:ps-8">
                @if (!hideStepper()) {
                    <apcam-client-progress-stepper
                        [items]="items"
                        [activeStep]="step" />
                }
            </div>
            @if (step() > 0) {
                <button
                    mat-flat-button
                    color="primary"
                    class="rem-big btn-back"
                    [disabled]="stepBackDisabled"
                    (click)="onBack()">
                    <mat-icon [svgIcon]="CustomIconsEnum.STEP_BACK"></mat-icon>
                    {{ 'shared.clientProgressHeader.back' | translate }}
                </button>
            }
        </div>
    </div>
</header>
